import { Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, RadioField, Tabs } from '@roc/ui';
import { CdaAndAppraisalOrderDetailsStore, useDocumentStore, WithDocumentActions } from '@roc/feature-documents';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { TamariskPayment } from '../../tamariskPayment/tamariskPayment';
import { Document } from '@roc/feature-types';
import { SelectField } from '@roc/ui';
import { CDAOrderDetails } from '../cdaOrderDetailsTab/CDAOrderDetails';
import { AMCEnum, isFixAndFlip, isGroundUp } from '@roc/feature-utils';
import { AppraisalOrderDetailsDashboards } from '../appraisalOrderDetailsTab/AppraisalOrderDetailsDashboards';
import { ARR, CDA, CDA_ARR_ORDER_DETAILS, insertIf, LoanSubType, ONE_PAYMENT, SECONDARY_VALUATION } from '@roc/feature-utils';
import { useStore } from 'apps/client-portal-public/src/app/hooks';
import { AppraisalDetails1004d } from '../../1004dAppraisalDetails/appraisalDetails1004d';
import { NoCDAAvailable } from '../cdaOrderDetailsTab/noCDAAvailable';
import { SecondaryValuation } from '../cdaOrderDetailsTab/secondaryValuation';
import { ManualArrSubmission } from '../cdaOrderDetailsTab/manualArrSubmission';
import { SecondValuationPaymentPending } from '../cdaOrderDetailsTab/SecondValuationPaymentPending';
import { SecondAppraisalSteps } from '@roc/feature-appraisals';
const APPRAISAL_PAYMENT_LOAN = "Appraisal_Loan";

const useStyles = makeStyles({
  instruction: {
    fontWeight: 600,
  },
  paymentDetails: {
    fontWeight: 800,
    marginTop: '20px',
    fontStyle: 'italic',
  },
  tabsContainer: {
    border: 'none !important',
    marginTop: '-35px',
  },
  container: {
    paddingTop: 12
  },
  closeButtonContainer: {
    paddingTop: 16,
  },
  button: {
    width: '100%',
  },
  amcSelect: {
    margin: '15px 0 0 0'
  }
});

const ConfirmationModal = ({ open, title, message, onConfirm, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { margin: 0, top: '50%', transform: 'translateY(-50%)' }
      }}
    >
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button testId='' variant="contained" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button testId='' variant="contained" color="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export enum LoanType {
  RESIDENTIAL_BRIDGE = 'Residential Bridge',
  RESIDENTIAL_TERM = 'Residential Term',
}

export type AppraisalOrderDetailsProps = {
  loan: any;
  document: Document;
  onUpdate?: () => void;
  onSubmitLoanPayments: () => void;
  onClick?: () => void;
  isInternal?: boolean;
  loanId?: number;
  isTamariskLender?: boolean;
  noTabClassname?: boolean;
};

const yesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const TamariskPaymentUrl = (props) => {

  const { loan, isInternal, isLenderWithTamarisk } = props;
  const classes = useStyles();
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { tamariskPaymentStore, cdaAndAppraisalOrderDetailsStore } = documentFormStore;
  useEffect(() => {
    if (isInternal)
      window.parent.postMessage('link-automated', '*');
  }, []);

  return (
    <Grid container className={classes.container}>
      <Grid item container spacing={2}>
        {!isLenderWithTamarisk &&
          <Grid item xs={11}>
            <TamariskYesNoQuestions
              loan={props.loan}
              document={props.document}
              onUpdate={props.onUpdate}
              onSubmitLoanPayments={props.onSubmitLoanPayments}
              onClick={props.onClick}
              handleConfirm={props.handleConfirm}
              handleClose={props.handleClose}
              isInternal={isInternal}
              store={cdaAndAppraisalOrderDetailsStore}
            />
          </Grid>}
        <Grid item xs={12}>
          <TamariskPayment
            borrowersEmail={tamariskPaymentStore.borrowersEmail}
            tamariskURL={tamariskPaymentStore.tamariskPaymentURL}
            entityId={loan.loanId}
            loanDetails={loan}
            type={APPRAISAL_PAYMENT_LOAN}
            paymentStatus={false}
            isInternal={isInternal}
          />
        </Grid>
        <Grid item container xs={12} justifyContent='flex-end' className={classes.closeButtonContainer}>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={props.handleClose}
              testId="cancel"
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
};

const TamariskYesNoQuestions = observer((props) => {
  const { loan, handleConfirm, isInternal, store }: {
    loan: any, handleConfirm: any, isInternal: any,
    store: CdaAndAppraisalOrderDetailsStore
  } = props;
  const [tamariskOptionValue, setTamariskOptionValue] = useState(false);
  const classes = useStyles();
  const [changeAmcDisable, setChangeAmcDisable] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    store.getAmcOptions();
    setTamariskOptionValue(loan.submitAppraisalWithTamarisk);
    if (isInternal)
      window.parent.postMessage('link-manual', '*');
  }, []);

  useEffect(() => {
    if (isFixAndFlip(loan.loanSubType) || isGroundUp(loan.loanSubType)) {
      if (loan.selectedAmcId) {
        store.setSelectedAmc(loan.selectedAmcId);
      } else if (store.amcOptions?.length) {
        store.setSelectedAmc(store.amcOptions[0]?.value);
      }
      setChangeAmcDisable(AMCEnum.VSAMC === store.selectedAMC);
    }
  }, [store.amcOptions]);

  const setTamariskValue = (value: string) => setTamariskOptionValue(value === 'true');

  const closeAmcModal = () => {
    setShowConfirmModal(false);
  };

  const confirmAmcSelection = () => {
    handleConfirm(tamariskOptionValue);
    setShowConfirmModal(false);
  };

  return (
    <Grid container justifyContent="center" spacing={1}>
      <Grid container item style={{ width: '89%' }}>
        {isFixAndFlip(loan.loanSubType) || isGroundUp(loan.loanSubType) ?
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 600 }}>Which AMC would you like to use?</Typography>
            <SelectField
              value={store.selectedAMC ?? ''}
              required={true}
              options={store.amcOptions ?? []}
              onChange={value => store.setSelectedAmc(value)}
              fullWidth
              variant={'outlined'}
              testId={'amcId'}
              className={classes.amcSelect}
              disabled={!isInternal}
            />
          </Grid> : <Grid item xs={12}>
            <Typography style={{ fontWeight: 600 }}>Will the borrower be using Tamarisk for Appraisal?</Typography>
            <RadioField
              name="loanPaymentsDecision"
              value={tamariskOptionValue}
              options={yesNoOptions}
              onChange={value => setTamariskValue(value)}
              fullWidth
              row
              testId="loanPaymentsDecision"
            />
          </Grid>}
      </Grid>
      <Grid item container style={{ width: '89%', paddingBottom: 12 }}>
        <Grid item>
          <WithDocumentActions
            component={Button}
            document={props.document}
            variant="contained"
            color="primary"
            onClick={() => (isFixAndFlip(loan.loanSubType) || isGroundUp(loan.loanSubType)) ? setShowConfirmModal(true) : handleConfirm(tamariskOptionValue)}
            testId="confirm"
            disabled={(isFixAndFlip(loan.loanSubType) || isGroundUp(loan.loanSubType)) ? !isInternal : ((loan.submitAppraisalWithTamarisk && tamariskOptionValue) || (!loan.submitAppraisalWithTamarisk && !tamariskOptionValue))}
            className={classes.button}
          >
            Confirm
          </WithDocumentActions>
        </Grid>
      </Grid>
      <ConfirmationModal
        open={showConfirmModal}
        title="Confirm AMC"
        message={store.selectedAMC !== AMCEnum.VSAMC && loan?.selectedAmcId === AMCEnum.VSAMC ? "Changing the AMC will cancel the existing order. Do you want to continue?" : "Please confirm the selected AMC?"}
        onConfirm={confirmAmcSelection}
        onClose={closeAmcModal}
      />
    </Grid>
  )
});

const TamariskUploadDocuments = ({ isInternal }) => {
  const classes = useStyles();
  const { documentStore } = useDocumentStore();

  const handleClose = () => {
    if (isInternal) {
      window.parent.postMessage('close-modal', '*');
      window.parent.postMessage('clear-style', '*');
    } else {
      documentStore.documentFormStore.setCurrentForm(null);
    }
  };

  return (<Grid container justifyContent="center" className={classes.container}>
    <Grid item xs={11}>
      <Typography variant="body1">Please upload the Appraisals reports to the corresponding line item in the Subject Property section(s)</Typography>
    </Grid>
    <Grid item container xs={11} justifyContent='flex-end' className={classes.closeButtonContainer}>
      <Grid item>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
          testId="close"
          className={classes.button}
        >
          Close
        </Button>
      </Grid>
    </Grid>
  </Grid>)
}
export const AppraisalOrderDetails = observer((props: AppraisalOrderDetailsProps) => {

  const classes = useStyles();
  const [showRevisionTab, setShowRevisionTab] = useState(false);
  const { isInternal, loan, isTamariskLender, noTabClassname = false } = props;
  const { globalStore } = useStore();
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { cdaAndAppraisalOrderDetailsStore, appraisalRecertificationOrderDetailsStore } = documentFormStore;
  appraisalRecertificationOrderDetailsStore.setIsInternal(globalStore.isInternalPortal);
  cdaAndAppraisalOrderDetailsStore.setIsInternal(props.isInternal);
  cdaAndAppraisalOrderDetailsStore.loanStore.loanDetails = loan;
  const loanSubtype = loan.loanSubtype ? loan.loanSubtype : loan.loanSubType;
  const isSinglePropertyRental = loanSubtype === LoanSubType.SINGLE_PROPERTY;

  useEffect(() => {
    appraisalRecertificationOrderDetailsStore.isAnyAppraisalRevisionByLoanIdPresent()
      .then((isPresent) => {
        setShowRevisionTab(isPresent);
      })
    cdaAndAppraisalOrderDetailsStore.setLoanCdaPaymentUrl(null);
    cdaAndAppraisalOrderDetailsStore.setCdaLoading(false);
  }, []);
  useEffect(() => {
    cdaAndAppraisalOrderDetailsStore.setSecondAppraisalInformation(null);
    if (loan?.loanId && loan?.cdaEnabled && !isCdaPaymentDone) {
      cdaAndAppraisalOrderDetailsStore.getCdaPaymentUrl(loan.loanId);
    }
    if (isSinglePropertyRental) {
      cdaAndAppraisalOrderDetailsStore.getSecondAppraisalInformation(loan.loanId);
    }
  }, [loan?.loanId]);

  useEffect(() => {
    if (loan?.cdaEnabled && cdaAndAppraisalOrderDetailsStore.loanCdaPaymentUrl) {
      setPaymentUrl(cdaAndAppraisalOrderDetailsStore.loanCdaPaymentUrl);
    } else if (loan?.arrEnabled && loan?.arrPaymentURL) {
      setPaymentUrl(loan?.arrPaymentURL);
    }
  }, [cdaAndAppraisalOrderDetailsStore.loanCdaPaymentUrl]);

  // Tamarisk flags
  const allowDepositTypes = ['Appraisal_Standalone', 'Appraisal_Loan', 'ARR_CDA_Loan', 'CDA_Loan', 'AMC_Loan'];
  const firstPayment = loan.loanDepositData && loan.loanDepositData.depositReceived &&
    (allowDepositTypes.includes(loan.loanDepositData.depositType));
  const secondPayment = loan.loanDepositSecondAppraisalData && loan.loanDepositSecondAppraisalData.depositReceived;
  const isTamariskPaymentDone = firstPayment || secondPayment;
  const isTamariskDefault = loan.submitAppraisalWithTamarisk;
  const tamariskPaymentURL = loan.tamariskPaymentURL ?? null;

  // CDA flags
  const cdaArrReady = loan.cdaArrReady ?? false;
  const arrPaymentUrl = loan.arrPaymentURL;
  const [paymentUrl, setPaymentUrl] = useState(loan.arrEnabled ? arrPaymentUrl : null)
  const isCdaPaymentDone = loan.cdaLoanDepositData?.depositReceived;
  const isArrPaymentDone = loan.arrLoanDepositData?.depositReceived;

  const borrowersEmail = cdaAndAppraisalOrderDetailsStore.borrowersEmail;

  const [selectedTab, setSelectedTab] = useState(0);
  const [tamariskResponse, setTamariskResponse] = useState(null);

  const onTabChange = (e, index) => setSelectedTab(index);

  const isBridgeLoan = loan.loanType === LoanType.RESIDENTIAL_BRIDGE ||
    loanSubtype === LoanSubType.SINGLE_PROPERTY_MULTIFAMILY ||
    loanSubtype === LoanSubType.MULTIFAMILY_TERM_PORTFOLIO;
  const showCdaArrTab = loan.showCDATab || globalStore.isInternalPortal;
  const showSecondaryValuation = isSinglePropertyRental && !loan.showCDATab
    && cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation
    && cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.allFirstAppraisalIn;

  const secondAppraisalPaid = showSecondaryValuation && (secondPayment ||
    (loan?.secondAppraisalPaymentType === ONE_PAYMENT && firstPayment));

  const showLink = loan.selectedAmcId ? loan.selectedAmcId : isTamariskDefault ? 1 : 3;
  const TABS = (isBridgeLoan && showRevisionTab) ? [
    {
      label: 'Summary',
    },
    {
      label: 'Revised Appraisal Details',
    },
  ] : isBridgeLoan ? [
    {
      label: 'Summary',
    },
  ] :
    [
      {
        label: 'Summary',
      },
      {
        label: CDA_ARR_ORDER_DETAILS
      },
      ...insertIf(showSecondaryValuation && globalStore.isInternalPortal, [{
        label: SECONDARY_VALUATION,
      }]),
      ...insertIf(showRevisionTab, [{
        label: 'Revised Appraisal Details',
      }]),
    ]

  const handleClose = () => {
    if (isInternal) {
      window.parent.postMessage('close-modal', '*');
      window.parent.postMessage('clear-style', '*');
    }

    documentStore.documentFormStore.setCurrentForm(null);
  };

  const handleConfirm = async (tamariskSelected) => {
    if (isFixAndFlip(loan.loanSubType) || isGroundUp(loan.loanSubType)) {
      await cdaAndAppraisalOrderDetailsStore.changeAMCForLoan(cdaAndAppraisalOrderDetailsStore.selectedAMC);
    } else {
      await cdaAndAppraisalOrderDetailsStore.updateAppraisalAndCdaCheck(cdaAndAppraisalOrderDetailsStore.selectedAMC, tamariskSelected, 'APPRAISAL', false);
    }
    setTamariskResponse(tamariskSelected);
    cdaAndAppraisalOrderDetailsStore.loanStore.loanDetails.submitAppraisalWithTamarisk = tamariskSelected;
    cdaAndAppraisalOrderDetailsStore.loanStore.fetchLoanDetails(loan.loanId);
  }

  const handleCdaResponse = async (value, cdaRushed) => {
    const response = await cdaAndAppraisalOrderDetailsStore.updateAppraisalAndCdaCheck(cdaAndAppraisalOrderDetailsStore.selectedAMC, false, value.toUpperCase(), cdaRushed);
    if (response) {
      switch (value) {
        case CDA:
          cdaAndAppraisalOrderDetailsStore.loanStore.loanDetails.cdaEnabled = true;
          break;
        case ARR:
          cdaAndAppraisalOrderDetailsStore.loanStore.loanDetails.arrEnabled = true;
          break;
      }
      setPaymentUrl(response);
    }
  }

  const tabContentRenderer = (tab) => {
    if (tab === 0) {
      if (isTamariskPaymentDone) {
        return (
          <AppraisalOrderDetailsDashboards
            loanId={props.loan.loanId}
            isInternal={isInternal}
          />);
      } else if (tamariskResponse === true || (showLink && tamariskPaymentURL)) {
        return (<TamariskPaymentUrl
          loan={props.loan}
          document={props.document}
          onUpdate={props.onUpdate}
          onSubmitLoanPayments={props.onSubmitLoanPayments}
          onClick={props.onClick}
          isInternal={cdaAndAppraisalOrderDetailsStore.isInternal}
          handleConfirm={handleConfirm}
          handleClose={handleClose}
          isLenderWithTamarisk={isTamariskLender}
        />);
      } else if (!isTamariskDefault || isTamariskDefault === null || isTamariskDefault === undefined) {
        return (
          <TamariskYesNoQuestions
            loan={props.loan}
            document={props.document}
            onUpdate={props.onUpdate}
            onSubmitLoanPayments={props.onSubmitLoanPayments}
            onClick={props.onClick}
            handleConfirm={handleConfirm}
            isInternal={isInternal}
            store={cdaAndAppraisalOrderDetailsStore}
          />);
      } else if (tamariskResponse === false || isTamariskDefault === false) {
        return (<TamariskUploadDocuments isInternal={isInternal} />);
      }
    }
    else if (TABS[tab].label === SECONDARY_VALUATION) {
      if (isInternal) {
        return <SecondAppraisalSteps
          loanId={props.loan.loanId} />
      } else {
        return <SecondaryValuation
          loan={loan}
          globalStore={globalStore}
          handleClose={handleClose}
          isInternal={isInternal}
          cdaAndAppraisalOrderDetailsStore={cdaAndAppraisalOrderDetailsStore}
        />
      }
    }
    else if (TABS[tab].label === CDA_ARR_ORDER_DETAILS) {
      if (secondAppraisalPaid) {
        return <ManualArrSubmission
          loan={props.loan}
          isInternal={isInternal}
          isCda={loan?.cdaEnabled}
          isArr={loan?.arrEnabled}
          onConfirm={handleCdaResponse}
          url={paymentUrl}
          borrowerEmail={borrowersEmail}
          isCdaPaymentDone={isCdaPaymentDone}
          isArrPaymentDone={isArrPaymentDone}
        />;
      } else if (!cdaArrReady) {
        return <NoCDAAvailable globalStore={globalStore} handleClose={handleClose} />
      } else if (isCdaPaymentDone || isArrPaymentDone) {
        return <CDAOrderDetails
          loanId={props.loan.loanId}
          isInternal={isInternal}
          isCda={loan?.cdaEnabled}
          isArr={loan?.arrEnabled}
          onConfirm={handleCdaResponse}
          url={paymentUrl}
          borrowerEmail={borrowersEmail}
          isCdaPaymentDone={isCdaPaymentDone}
          isArrPaymentDone={isArrPaymentDone}
          subtype={props.loan.loanSubType}
        />;
      } else if (!cdaAndAppraisalOrderDetailsStore.cdaLoading
        && LoanSubType.RENTAL_PORTFOLIO === props.loan.loanSubType) {
        return <ManualArrSubmission
          loan={props.loan}
          isInternal={isInternal}
          isCda={loan?.cdaEnabled}
          isArr={loan?.arrEnabled}
          onConfirm={handleCdaResponse}
          url={paymentUrl}
          borrowerEmail={borrowersEmail}
          isCdaPaymentDone={isCdaPaymentDone}
          isArrPaymentDone={isArrPaymentDone}
        />;
      } else if (!cdaAndAppraisalOrderDetailsStore.cdaLoading) {
        return <SecondValuationPaymentPending isInternal={isInternal} />
      }
    }
    else if (TABS[tab].label === 'Revised Appraisal Details') {
      return <AppraisalDetails1004d
        loanId={props.loan.loanId}
        isInternal={appraisalRecertificationOrderDetailsStore.isInternal}
        isCda={loan?.cdaEnabled}
        isArr={loan?.arrEnabled}
        onConfirm={handleCdaResponse}
        url={paymentUrl}
        borrowerEmail={borrowersEmail}
        isCdaPaymentDone={isCdaPaymentDone}
        isArrPaymentDone={isArrPaymentDone}
      />;
    }
    return null;
  };

  return (
    <>
      {TABS.length > 1 &&
        <Tabs
          tabs={TABS}
          selectedTab={selectedTab}
          onTabChange={onTabChange}
          className={!noTabClassname && classes.tabsContainer}
        />
      }
      {tabContentRenderer(selectedTab)}
    </>
  );
});
